import { call, put, takeLatest } from "redux-saga/effects";
import { authApi } from "../../../api/auth/authApi";
// import { ILoginRequest } from "../../../model/request/auth/ILoginRequest";
// import { IBaseRespone } from '../../../model/respone/IBaseRespone';
// import { eAuthActionTypeIds, IAuthActions } from '../../action-types/auth/IAuthActions';
import { rootActions } from "../../actions/rootActions";
import {
  eAuthActionTypeIds,
  IAuthActions,
} from "../../action-types/auth/IAuthActions";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { ILoginRequest } from "../../../model/request/ILoginRequest";
import { ILoginVNPTRequest } from "../../../model/request/auth/ILoginVNPTRequest";

export function* authSaga(): any {
  yield takeLatest(eAuthActionTypeIds.LOGIN_START, loginWorker);
  yield takeLatest(eAuthActionTypeIds.LOGOUT_START, logoutWorker);
  yield takeLatest(eAuthActionTypeIds.GET_USER_INFO_START, getDetailWorker);
  yield takeLatest(eAuthActionTypeIds.LOGIN_VNPT_START, loginVNPTWorker);
  yield takeLatest(
    eAuthActionTypeIds.GET_USER_INFO_VNPT_START,
    getDetailVNPTWorker
  );
}

function* loginWorker(action: IAuthActions): any {
  const res: IBaseResponse = yield call(
    authApi.logIn,
    action.payload as ILoginRequest
  );
  if (res.is_success) {
    yield put(rootActions.auth.LOGIN_SUCCESS(res.data));
  } else {
    yield put(rootActions.auth.LOGIN_ERROR(res.message ?? "Có lỗi"));
  }
}

function* getDetailWorker(action: IAuthActions): any {
  const res: IBaseResponse = yield call(authApi.getUser);
  if (res.is_success) {
    yield put(rootActions.auth.GET_USER_INFO_SUCCESS(res.data));
  } else {
    yield put(rootActions.auth.GET_USER_INFO_ERROR(res.message ?? "Có lỗi"));
  }
}

function* loginVNPTWorker(action: IAuthActions): any {
  const res: IBaseResponse = yield call(
    authApi.logInVNPT,
    action.payload as ILoginVNPTRequest
  );
  if (res.is_success) {
    yield put(rootActions.auth.LOGIN_VNPT_SUCCESS(res.data));
    // Chỉ lấy thông tin user khi đăng nhập thành công.
    // Trước đây gọi GET_USER_INFO_START cả khi lỗi -> gây vòng lặp đổi state liên tục.
    yield put(rootActions.auth.GET_USER_INFO_START(undefined));
  } else {
    yield put(rootActions.auth.LOGIN_VNPT_ERROR(res.message ?? "Có lỗi"));
  }
}

function* logoutWorker(): any {
  const res: IBaseResponse = yield call(authApi.logOut);
  if (res.is_success)  {  
    yield put(rootActions.auth.LOGOUT_SUCCESS(res.data));
  } else {
    yield put(rootActions.auth.LOGOUT_ERROR(res.message ?? "Đăng xuất thất bại"));
  }
}

function* getDetailVNPTWorker(action: IAuthActions): any {
  const res: IBaseResponse = yield call([authApi, authApi.getUserVNPT]);
  if (res.is_success) {
    yield put(rootActions.auth.GET_USER_INFO_VNPT_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.auth.GET_USER_INFO_VNPT_ERROR(res.message ?? "Có lỗi")
    );
  }
}
